import { ParameterType } from '@/study-search/enums';
import { TitleBase } from './TitleBase';

export default class TitleCountryMultiple extends TitleBase {
	protected canHandle(): boolean {
		return this.multiValueFilters.length >= 1 && this.multiValueFilters.some((_) => _.type === ParameterType.COUNTRY);
	}

	protected getPageTitle(): string {
		return `${this.titlePortalType} in selected countries`;
	}

	protected getMetaDescription(): string {
		return this.buildMetaDescription(this.titlePortalType, ' in selected countries');
	}
}
